import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    reportSelectWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    inputLabel: {
        color: theme.palette.text.secondary,
        textAlign: "left",
    },
    selectRow: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        columnGap: theme.spacing(4),
    },
    select: {
        backgroundColor: theme.palette.secondary.main,
        width: "290px",
        maxWidth: "100%",
        height: "45px",
        borderRadius: "4px",
        boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
        marginBottom: "5px",
        fontFamily: "Source Sans 3 !important",
    },
    menuItem: {
        fontFamily: "Source Sans 3 !important",
    },
    dateRangeLabel: {
        "&.MuiTypography-root": {
            color: theme.palette.text.secondary,
            fontFamily: "Source Sans 3",
            fontSize: 14,
            fontWeight: 600,
            marginBottom: "5px",
            whiteSpace: "nowrap",
        },
    },
}));
